import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Wrapper = styled.ul`
  display: flex;
  width: 280px;
  height: 280px;
  gap: 2rem;
  padding: 0;
  list-style-type: none;
  box-shadow: ${theme.shadow.lv2};
  border-radius: 40px;

  li {
    width: 100%;
  }

  .card {
    position: relative;
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 40px;
    overflow: hidden;
    text-decoration: none;

    .cardImage {
      object-fit: cover;
      width: 100%;
      height: 75%;
    }

    .cardOverlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      border-radius: 40px 40px 0 0;
      background-color: #fff;
      transform: translateY(100%);
      transition: 0.2s ease-in-out;

      .cardHeader {
        position: relative;
        display: flex;
        align-items: center;
        gap: 2em;
        padding: 1.5em;
        border-radius: 40px 40px 0 0;
        background-color: #fff;
        transform: translateY(-100%);
        transition: 0.2s ease-in-out;

        .cardHeaderText {
          width: 100%;

          .cardTitle {
            overflow-wrap: break-word;
            line-height: 25px;
          }

          .cardTitle,
          .cardSubTitle {
            font-size: 1em;
            color: #6a515e;
          }
        }
      }

      .actions {
        padding: 0 2em 2em;
        margin: 0;
        display: flex;
        column-gap: 0.5rem;

        svg {
          width: 20px;
          height: 20px;
          transform: scale(1);

          :hover {
            cursor: pointer;
            transform: scale(1.1);
          }
        }
      }
    }

    :hover {
      .cardOverlay,
      .cardHeader {
        transform: translateY(0);
      }
    }
  }

  .isLoading {
    display: block;
    z-index: 2;
    width: 100%;
    height: 267px;
    background: #eee;
    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
`;
